// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AirportFilterController from "./airport_filter_controller"
application.register("airport-filter", AirportFilterController)

import AutoScrollController from "./auto_scroll_controller"
application.register("auto-scroll", AutoScrollController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ConfirmController from "./confirm_controller"
application.register("confirm", ConfirmController)

import ExclusiveDropdownController from "./exclusive_dropdown_controller"
application.register("exclusive-dropdown", ExclusiveDropdownController)

import FadeController from "./fade_controller"
application.register("fade", FadeController)

import FormSubmitController from "./form_submit_controller"
application.register("form-submit", FormSubmitController)

import ImageClipboardController from "./image_clipboard_controller"
application.register("image-clipboard", ImageClipboardController)

import ModalOpenController from "./modal_open_controller"
application.register("modal-open", ModalOpenController)

import InboundCheckController from "./inbound_check_controller"
application.register("inbound-check", InboundCheckController)

import InlineEditController from "./inline_edit_controller"
application.register("inline-edit", InlineEditController)

import PhotoUploadController from "./photo_upload_controller"
application.register("photo-upload", PhotoUploadController)

import PhotoFanController from "./photo_fan_controller"
application.register("photo-fan", PhotoFanController)

import UpdateModeController from "./update_mode_controller"
application.register("update-mode", UpdateModeController)
